import { render, staticRenderFns } from "./ListDgo.vue?vue&type=template&id=190ac51b&scoped=true"
import script from "./ListDgo.vue?vue&type=script&lang=js"
export * from "./ListDgo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190ac51b",
  null
  
)

export default component.exports